import { useDispatch } from 'react-redux'
import { requestGlobalToken } from '../store/user/actions'
import { selectTenant } from '../store/user/actions'
import { roles } from '../components/fields/MultipleRolePicker'
import { useTenantOrGlobalAdmin } from '../hooks/useTenantOrGlobalAdmin'

export const useForcePermissionsUpdate = (
  onSuccess = null,
  onFinally = null
) => {
  const dispatch = useDispatch()
  const { isGlobalAdmin, actingRole, tenant } = useTenantOrGlobalAdmin()

  return () => {
    if (isGlobalAdmin) {
      dispatch(requestGlobalToken(false)).then(onSuccess).finally(onFinally)
    } else {
      const role = roles.find((r) => r.key === actingRole)
      dispatch(selectTenant({ tenant, role }))
        .then(onSuccess)
        .finally(onFinally)
    }
  }
}
